<div
  #chart
  class="Desktop__Graph"
  [ngClass]="
    config.type === 'standard' ? 'BarGraph__Content' : 'GroupBarGraph__Content'
  "
></div>
@for (bar of mobileGroupedBarData; track bar) {
  <section class="Mobile__Graph">
    @if (bar.name) {
      <div class="MobileYearEndSummary__GroupName t-bold">
        {{ bar.name }}
      </div>
    }
    @for (catValue of bar.values; track catValue) {
      <div class="MobileYearEndSummary__Graph">
        <div class="MobileYearEndSummary__CostDetails">
          <p>{{ catValue.category }}</p>
          <p class="t-bold">{{ catValue.value | currency }}</p>
        </div>
        <mat-progress-bar
          mode="determinate"
          [matProgressBarColor]="catValue.color"
          [value]="catValue.percentage"
        ></mat-progress-bar>
        <div class="MobileYearEndSummary__GraphXAxis">
          <div class="Mobile__Text">{{ minValue | currency }}</div>
          <div class="Mobile__Text">{{ maxValue | currency }}</div>
        </div>
      </div>
    }
  </section>
}
